define([
   	"dojo/_base/declare"
], function(declare) {

	return declare(null,{
		// String: value
		value: null,

		// String: attribute type
		type: null,

		// String: query key
		queryKey: null,

		constructor: function(value, type, queryKey) {
			this.value = value;
			this.type = type;
			this.queryKey = queryKey;
		}
	});
});